/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  AvatarSettings,
  AvatarSettingsInterface,
} from "../../contracts/AvatarSettings";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "AvatarActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "collectionAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isAvatarCollection",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "AvatarDeactivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "BirthdayPresentClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "CollectionApprovalUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "ExternalAvatarActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "powerId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expirationTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "PowerActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "PowerActivationFeeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "PowersAccessActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "telegram",
        type: "string",
      },
    ],
    name: "TelegramChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POWER_DURATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collectionAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "activateAvatar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "powerId",
        type: "uint256",
      },
    ],
    name: "activatePower",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "activatePowerAccess",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "activeAvatars",
    outputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isAvatarCollection",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isPowersAllowed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collectionAddress",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "approveCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "approvedCollections",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "birthdayPresentClaimPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimBirthdayPresent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "deactivateAvatar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "powerId",
        type: "uint256",
      },
    ],
    name: "getPowerEndingTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStatistic",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getYear",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasPowerA",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasPowerB",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasPowerC",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "hasPowerD",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractManagerAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "birthdayTimestamp",
        type: "uint256",
      },
    ],
    name: "isBirthdayInRange",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "isBirthdayPresentAvailable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPowerAccessActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "powerActivationFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_days",
        type: "uint256",
      },
    ],
    name: "setBirthdayPresentClaimPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "setTokenName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_telegram",
        type: "string",
      },
    ],
    name: "setTokenTelegram",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "updatePowerActivationFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "userPowers",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type AvatarSettingsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AvatarSettingsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AvatarSettings__factory extends ContractFactory {
  constructor(...args: AvatarSettingsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<AvatarSettings> {
    return super.deploy(overrides || {}) as Promise<AvatarSettings>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): AvatarSettings {
    return super.attach(address) as AvatarSettings;
  }
  override connect(signer: Signer): AvatarSettings__factory {
    return super.connect(signer) as AvatarSettings__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AvatarSettingsInterface {
    return new utils.Interface(_abi) as AvatarSettingsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AvatarSettings {
    return new Contract(address, _abi, signerOrProvider) as AvatarSettings;
  }
}
